module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }), _c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _c('h3', {
    staticClass: "chapterTitle"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/005TOC#chapter_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("AMBER AT THE WINDOW IN HURRICANE SEASON")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("B")])]), _vm._v("y two o’clock the sky had gone to ash. Amber pushed a blond lock behind her ear, stray hairs glancing off a steel row of studs driven like garden stakes through the cartilage of her helix and lobe. Her other hand still held the roll of duct tape with which she’d reinforced the window, the glass marked now with a dull silver "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("X")]), _vm._v(". She looked around it, out at the world. She wore pre-faded jeans and a small tee shirt. Stylish, but not quite "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("in")]), _vm._v(" style, the wardrobe alluded to punk rock, outlet malls, and other holdover habits from high school. A year later, when you saw her in her no-longer-quite-new skirt (the plaid one so short you kept catching glimpses of her white white underwear) she seemed like someone else altogether. You were all wet from having jumped into the aboveground pool. She gave you an old Misfits tee shirt and "), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("a pair of JNCOs to wear while your clothes dried, and you thought, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oh, I remember Amber now")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("When she smiled her cheeks turned to waxed apples but she wasn’t smiling there at the window. She was worrying that the oak tree might come through her ceiling, wood obliterating wood, like a miracle running backward.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the glass, between the silver diagonals of tape, she saw her own ghost. She stared through the translucent creature and focused on the measly expanse of grass between her building and the deserted street, its shuttered shops and condemned strays. Beyond that there was only the storm. It was really going to happen. And you weren’t there.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Your name was Patrick. You were still away, maybe out somewhere with your new friends or jerking off in some bathroom thinking about Marissa, who you never told Amber about, and who, you should never forget, I had before you did. I always wondered what you saw in her that I couldn’t, what made her off-ness on for you, but mostly I was just glad she began stopping at your bedroom door and left my end of the hallway alone. She was an ugly drunk, which was part of it, I already had one of those in my life—but this isn’t about Marissa, it’s not about you, and I won’t allow it to devolve into another damn soliloquy for Kim. This is about Amber, and the thing that wore away at us like waves beating beach sand until the day I kissed her and she liked it. We didn’t tell you. It was ours. We could have fucked maybe twice before the remorse caught up with us. Do you suppose we did?")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("She was a weather freak, as you’ll recall, crushed out on every forecaster, even the old fat ones. Late nights would dissolve into early mornings while she waited for her favorites, with their toupees and full-color satellite imagery. Sometimes I’d find her in the living room appraising the ten-day forecast with a sexualized eye not unlike the one I cast on her or you cast on whoever you weren’t ignoring just then. The predictions were always dire. The animated projections repeated, over and over, as if scratched by a DJ. She tracked the progress of every named and unnamed storm.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She told me this one would be the worst and remain the worst for a while. That’s why I picked it to tell about, whatever its name was or would have been. There’s always a new worst; only tenure varies. I was eager to see the city pelted and drubbed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But I wasn’t there either. This picture of Amber at the window in hurricane season is a second-rate sketch, my little vision, an unfair summation of an era—a summer—we spent in grand subtropical poverty, sipping rum drinks so sweet they were almost sour and boasting that we were the people who did not listen to Jimmy Buffett. We listened to sad songs and the birds that haunted the oaks between the duplexes and low-rise apartments like the one Amber hadn’t moved into yet. The one where you found her again.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("Cars were rare and there were stars at night. We stood on the porch. On the sidewalk some genius had spray-painted "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("EVERYTHING HERE IS THE BEST THING EVER")]), _vm._v(" and nobody from ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("the city ever came to clean it up. I began to believe we were the secret owners of the world and everything in it: our shitty rental home; that one bar on Tenth that we liked; the whole state from the Alabama border over to St. Augustine, down past the Rat Kingdom all the way to Hemingway House and the beaches from which you can practically spit on Cuba. Amber would sleep in your bed, the window open, smelling the early summer and the last of you in the sheets. Hurricane season hadn’t started. Every night was balmy. We’d make ridiculous breakfasts at all hours, bacon and pancakes, stacks and piles, heaps, and wonder how you were doing, if you would ever send for her or wash back up here or never call again, or what. She never did the laundry. Sometimes I wouldn’t sleep for days.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  })]), _c('a', {
    attrs: {
      "id": "page20"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page20"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-730d518a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006chapter01.vue
// module id = 72
// module chunks = 0